class AcademySubscription {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {
    this.$quantity_container = $( ".quantity-container" )
    this.$academy_subscriptions = $( "#academy-subscriptions" )
  }

  bindEvents () {
    this.updateNumber()
    this.addToCart()
    this.$academy_subscriptions.find( '.subscription-tab input[name=academy_period_radio]' ).on( 'change',
      this.handleDurationChange.bind( this )
    )
    this.handleInputChange()
  }

  handleDurationChange () {
    this.$academy_subscriptions.find( 'input[name=quantity]' ).val( 1 ).trigger('change')

    $self = this
    const selected = this.$academy_subscriptions.find( '.subscription-tab input[name=academy_period_radio]:checked' ).val()

    this.$academy_subscriptions.find( '.rate' ).each( function ( e ) {
      if ( 'annual' === selected ) {
        $( this ).html( `$${ $( this ).data( 'yearly' ) }<span class="duration">/year</span>` )
        $self.$academy_subscriptions.find( '.subscription-plan.best-seller' ).removeClass( 'monthly' )
      } else if ( 'monthly' === selected ) {
        $( this ).html( `$${ $( this ).data( 'monthly' ) }<span class="duration">/monthly</span>` )
        $self.$academy_subscriptions.find( '.subscription-plan.best-seller' ).addClass( 'monthly' )
      }

    } )
  }

  handleInputChange () {
    this.$academy_subscriptions.find( 'input[name=quantity]' ).on( 'change', function ( e ) {
      const selectedPeriod = $( 'input[name=academy_period_radio]:checked' ).val()
      const $rateContainer = $(this).parents(':eq(2)', $(this))

      const unitPrice = selectedPeriod === 'annual' ? $( '.rate', $rateContainer ).attr( 'data-yearly' ) : $( '.rate', $rateContainer ).attr( 'data-monthly' )
      const userNumber = $( this ).val()

      $rateContainer.find('.rate').html( `$${ userNumber * unitPrice } <span class="duration">/ ${ selectedPeriod === 'annual' ? 'yearly' : 'monthly' }</span>` )
    } )
  }

  updateNumber ( e ) {
    this.$quantity_container.find( 'button.btn-number' ).on( 'click', function ( e ) {
      const operationType = $( this ).data( 'type' )
      const currentValue = parseInt( $( 'input[type=number]', $( this ).parent() ).val() )
      const min = $( 'input[type=number]', $( this ).parent() ).attr( 'min' ) ?? 1

      if ( 'minus' === operationType && currentValue > min ) {
        $( 'input[type=number]', $( this ).parent() ).val( currentValue - 1 ).trigger( 'change' )
      } else if ( 'plus' === operationType ) {
        $( 'input[type=number]', $( this ).parent() ).val( currentValue + 1 ).trigger( 'change' )
      }
    } )
  }

  addToCart () {
    this.$quantity_container.find( 'button#add_to_cart' ).on( 'click', function ( e ) {
      const selectedPlan = $( this ).data( 'plan' )
      const selectedPeriod = $( 'input[name=academy_period_radio]:checked' ).val()
      const numberOfUsers = $( 'input[type=number]', $( this ).parents( ':eq(1)' ) ).val()

      $( `select#academy_period_select option[value=${ selectedPeriod }]` ).prop( 'selected', true )
      $( `select#academy_plan_select option[value=${ selectedPlan }]` ).prop( 'selected', true )
      $( '#academy_num_users' ).val( numberOfUsers )

      $( '#add_training_to_cart' ).trigger( 'click' )
      $( '#default_checkout' ).trigger( 'click' )
    } )
  }
}

new AcademySubscription()
